const storage = {
    getAccessToken() {
        return localStorage.getItem('access-token');
    },

    setAccessToken(token) {
        localStorage.setItem('access-token', token);
    },

    removeAccessToken() {
        localStorage.removeItem('access-token');
    },

    getRefreshToken() {
        return localStorage.getItem('refresh-token');
    },

    setRefreshToken(token) {
        localStorage.setItem('refresh-token', token);
    },

    removeRefreshToken() {
        localStorage.removeItem('refresh-token');
    }
};

export default storage;
